<template>
  <!-- 首页 -->
  <div class="home">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <!-- 头部 -->
      <header>
        <img src="../../assets/img/home/home_logo@2x.png" alt="" />
      </header>
      <div class="banner">
        <div class="home_bg"></div>
        <div class="banner-bg"></div>
        <!-- 轮播图 -->
        <div class="banner-pic">
          <van-swipe
            class="my-swipe"
            :autoplay="3000"
            indicator-color="#93683D"
          >
            <van-swipe-item
              v-for="item in homeList"
              :key="item.id"
              @click="bannerDetail(item)"
            >
              <img :src="item.pic" alt=""
            /></van-swipe-item>
          </van-swipe>
        </div>
        <!-- 公告 -->
        <div class="notice_banner">
          <van-swipe
            class="swipe"
            vertical
            :show-indicators="false"
            autoplay="2000"
          >
            <van-swipe-item
              v-for="notice in newsList"
              :key="notice.id"
              class="swip_item"
              :swipeTo="notice.url"
              @click="toNews(notice)"
            >
              <img src="../../assets/img/home/icon_notice@2x.png" alt="" />
              <span>{{ notice.title }}</span>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
      <!-- 按钮 -->
      <div class="home_btn">
        <ul>
          <router-link to="/welfare" tag="li">
            <img
              src="../../assets/img/home/home_btn/home_btn_welfare@2x.png"
              alt=""
            />
            <p>积分商城</p>
          </router-link>
          <router-link to="/collection" tag="li">
            <img
              src="../../assets/img/home/home_btn/home_btn_collection@2x.png"
              alt=""
            />
            <p>我的收藏</p>
          </router-link>
          <router-link to="/order" tag="li">
            <img
              src="../../assets/img/home/home_btn/home_btn_order@2x.png"
              alt=""
            />
            <p>我的订单</p>
          </router-link>
          <router-link to="/personal" tag="li">
            <img
              src="../../assets/img/home/home_btn/home_btn_personal@2x.png"
              alt=""
            />
            <p>个人中心</p>
          </router-link>
        </ul>
      </div>
      <!-- 选购区域 -->
      <div class="shop" v-for="(item, i) in shopList" :key="item.id" v-show="item.lists[i]">
        <div class="title">
          <h2>{{ item.title }}</h2>
          <router-link
            :to="{ name: '商品分类', params: { typeid: i + 1 } }"
            tag="div"
          >
            <span>更多</span
            ><img src="../../assets/img/home/btn_more@2x.png" alt=""
          /></router-link>
        </div>
        <ul class="shop-pic">
          <router-link
            v-for="shop in item.lists"
            :to="{ name: '商品详情', params: { id: shop.id } }"
            tag="li"
            :key="shop.id"
            :style="item.lists.length == 1 ? 'width:100%' : 'width:33.3333%'"
          >
            <div class="img">
              <img
                src="../../assets/img/home_2.png"
                alt=""
                v-show="shop.id == 2"
                style="width: 100%"
              />
              <img
                src="../../assets/img/home_1.png"
                v-show="shop.id == 1"
                style="width=100%"
              />
              <!-- <img :src="shop.pic" alt="" /> -->
            </div>
            <div class="content">
              <div class="content_left">
                <p class="shop_title">{{ shop.title }}</p>
                <p class="nowMoney">
                  <span>￥</span
                  ><span style="font-weight: bold; font-size: 0.2rem">{{
                    parseInt(shop.price)
                  }}</span>
                  <span>{{
                    shop.price.substring(shop.price.indexOf("."))
                  }}</span>
                </p>
                <p class="market_price">
                  <span>￥</span>
                  <span>{{ shop.market_price }}</span>
                </p>
              </div>
              <div class="content_right">
                <p v-show="item.lists.length === 1">
                  已售<span>{{
                    shop.buy > 1000
                      ? parseInt(shop.buy / 1000) + "k+"
                      : shop.buy
                  }}</span>
                </p>
              </div>
            </div>
          </router-link>
        </ul>
      </div>
    </van-pull-refresh>
  </div>
</template>
<script>
import { getList, weixinBind, getUserInfo } from '@/api/home.js'
import { Toast } from 'vant'
export default {
  data () {
    return {
      homeList: [],
      newsList: [],
      shopList: [],
      isLoading: false,
      count: 0,
      code: ''
    }
  },
  created () {
    if (window.location.href.split('code=')[1]) {
      const href = this.showWindowHref()
      this.code = href.code
      this.weixin()
    }

    getList()
      .then((res) => {
        this.homeList = res.data.backdata.banner
        this.newsList = res.data.backdata.news
        this.shopList = res.data.backdata.shop
        // 微信分享
        const config = {
          appId: 'wx90d063c3fc548e01',
          shareTitle: res.data.backdata.share.share_title,
          shareTxt: res.data.backdata.share.share_desc,
          shareUrl: res.data.backdata.share.share_url,
          imgUrl: res.data.backdata.share.share_pic
        }
        wxint(config)
      })
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {
    // 获取url query 拼接 参数
    showWindowHref () {
      var sHref = window.location.href
      var args = sHref.split('?')
      if (args[0] == sHref) {
        return ''
      }
      var arr = args[1].split('&')
      var obj = {}
      for (var i = 0; i < arr.length; i++) {
        var arg = arr[i].split('=')
        obj[arg[0]] = arg[1]
      }
      return obj
    },
    // 微信绑定
    weixin () {
      weixinBind({
        code: this.code
      }).then((res) => {
        if (res.data.msg == '微信未绑定') {
          sessionStorage.setItem('openid', res.data.backdata.openid)
          Toast('登陆后绑定手机号')
          this.$router.push('/login')
        } else {
          this.$router.push('/home')
          localStorage.setItem('userToken', res.data.backdata.token)
        }
      })
    },
    onRefresh () {
      setTimeout(() => {
        Toast('刷新成功')
        this.isLoading = false
        this.count++
      }, 1000)
    },
    toNews (val) {
      if (val.url) {
        this.$router.push({
          name: '文章详情',
          params: {
            id: val.id,
            article: val
          }
        })
      }
    },
    bannerDetail (val) {
      this.$router.push({
        name: '文章详情',
        params: {
          id: val.id,
          article: val
        }
      })
      // let aid = sessionStorage.getItem("aid");
      // let url = "";
      // if (aid) {
      //   url =
      //     this.commonRealmName +
      //     "/h5/?#" +
      //     this.$route.fullPath +
      //     "?aid=" +
      //     aid;
      // } else {
      //   url = this.commonRealmName + "/h5/?#" + this.$route.fullPath;
      // }
      // let config = {
      //   appId: "wx90d063c3fc548e01",
      //   shareTitle: this.commodityDetail.title,
      //   shareTxt: this.commodityDetail.desc,
      //   shareUrl: url,
      //   imgUrl: this.commodityDetail.pic,
      // };
      // wxint(config);
      if (val.url) {
        window.location.href = val.url
        // this.$router.push({
        //   name: "跳转链接",
        //   params: {
        //     url: val.url,
        //     newTitle: val.title,
        //   },
        // });
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
  background: #ffffff;
  padding-bottom: 0.57rem;

  header {
    width: 100%;
    height: 0.64rem;
    background-image: url("../../assets/img/home/top_bg_golden@2x.png");
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 0.75rem;
      height: 0.18rem;
    }
  }

  // 产品轮播图以及公告轮播图
  .banner {
    position: relative;
    width: 100%;
    height: 2.38rem;

    // 轮播图的背景图
    .home_bg {
      width: 100%;
      height: 1.16rem;
      background: url("../../assets/img/home/home_bg_golden@2x.png") no-repeat
        0rem 0rem;
      background-size: 100% 100%;
    }

    .banner-bg {
      position: absolute;
      top: 0.86rem;
      width: 100%;
      height: 1.16rem;
      background: url("../../assets/img/home/bg_banner_projection@2x.png")
        no-repeat 0rem 0rem;
      background-size: 100% 100%;
    }

    // 轮播图
    .banner-pic {
      width: 3.45rem;
      height: 1.79rem;
      position: absolute;
      transform: translateX(-50%);
      top: 0rem;
      left: 50%;

      .my-swipe .van-swipe-item {
        width: 100%;
        height: 1.79rem;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    // 公告
    .notice_banner {
      position: absolute;
      bottom: 0rem;
      left: 50%;
      transform: translateX(-50%);
      width: 3.45rem;
      height: 0.35rem;
      background: #ffffff;
      box-shadow: 0rem 0.05rem 0.1rem 0rem rgba(82, 39, 0, 0.04);
      border-radius: 0.06rem;
      font-size: 0.12rem;

      .swipe {
        height: 0.35rem;

        .swip_item {
          display: flex;
          align-items: center;
          width: 100%;
          height: 100%;

          img {
            width: 0.12rem;
            height: 0.13rem;
            margin: 0 0.11rem;
          }
        }
      }
    }
  }

  // 四个按钮
  .home_btn {
    padding: 0.3rem 0.26rem 0.35rem 0.25rem;

    ul {
      display: flex;
      width: 100%;
      justify-content: space-between;

      li {
        display: flex;
        flex-direction: column;
        color: #333333;
        font-size: 0.12rem;

        img {
          width: 0.44rem;
          height: 0.44rem;
          margin-bottom: 0.07rem;
        }
      }
    }
  }

  .shop {
    padding: 0 0.15rem;
    margin-bottom: 0.25rem;

    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.21rem;

      h2 {
        height: 0.2rem;
        font-size: 0.16rem;

        font-weight: bold;
        color: #94683e;
        line-height: 0.2rem;
      }

      div {
        display: flex;
        align-items: center;

        span {
          font-size: 0.12rem;

          font-weight: bold;
          color: #36363e;
          line-height: 0.2rem;
        }

        img {
          width: 0.06rem;
          height: 0.1rem;
          margin-left: 0.05rem;
        }
      }
    }

    .shop-pic {
      width: 102%;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;

      li {
        border-radius: 0.08rem;
        padding-bottom: 0.14rem;
        padding-right: 0.06rem;

        img {
          background: #fafafa;
          width: 100%;
        }

        // 下方的价格、标题
        .content {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;

          .content_left {
            p {
              line-height: 0.2rem;

              &.shop_title {
                height: 0.4rem;
                line-height: 0.4rem;
                font-size: 0.15rem;
                color: #343434;
              }

              &.nowMoney {
                font-size: 0.16rem;
                color: #94683e;
              }

              &.market_price {
                font-size: 0.12rem;
                text-decoration: line-through;
                color: #9a9a9c;
                height: 0.28rem;
                line-height: 0.28rem;
              }
            }
          }

          .content_right {
            p {
              height: 0.2rem;
              font-size: 0.12rem;
              color: #9a9a9c;
              height: 0.28rem;
              line-height: 0.28rem;
            }
          }
        }
      }
    }
  }
}
</style>
